import { appInfo } from './AppInfo';
var skstockAppInfo = {
    isPhone: function () {
        return appInfo.loginType === 2;
    },
    /**
     * 比较当前app版本号是否大于或等于目标版本号
     * @param version 目标版本号
     * @param options
     * @returns
     */
    compareVersion: function (version, options) {
        if (!version) {
            console.warn('版本比对异常：请传入要比对的版本号', version);
            return false;
        }
        var _options = {
            appVersion: appInfo.appVersion,
            isIncludeEqual: true
        };
        if (options) {
            Object.assign(_options, options);
        }
        var isSupport = false;
        var appVersion = _options.appVersion, isIncludeEqual = _options.isIncludeEqual;
        if (version === appVersion) {
            isSupport = isIncludeEqual;
        }
        else {
            var versionArr = version.split('.');
            var appVersionArr = appVersion.split('.');
            if (appVersionArr.length === versionArr.length) {
                for (var i = 0; i < appVersionArr.length; i++) {
                    if (appVersionArr[i] !== versionArr[i]) {
                        isSupport = appVersionArr[i] > versionArr[i];
                        break;
                    }
                }
            }
            else {
                isSupport = appVersionArr.length > versionArr.length;
            }
        }
        return isSupport;
    },
};
export default skstockAppInfo;
//# sourceMappingURL=skstockAppInfo.js.map